export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";